<template>
    <tr>
        <td v-if="!updatingData">
            <router-link :to="'/corridoringmap/' + this.corridoring.id">
                {{ corridoring.name }}
            </router-link>
        </td>
        <td v-else>
            <input v-model="newName" type="text" class="form-control" placeholder="Nom">
        </td>
        <td>
            <router-link :to="'/corridoringmap/' + this.corridoring.id" class="text-decoration-none">
                <CorridoringDisplay :corridoring="this.corridoring"/>
            </router-link>
        </td>
        <td v-if="!updatingData && !this.isViewer" class="text-end">
            <div class="me-4">
                <a data-bs-toggle="dropdown" href="#" class="btn p-1" aria-expanded="false">
                    <font-awesome-icon :icon="['fas', 'bars']"/>
                </a>
                <div class="dropdown-menu dropdown-menu-end" style="">
                    <a role="button" v-on:click="updatingData = true" class="dropdown-item">Modifier</a>
                    <a role="button" v-on:click="this.delete()" class="dropdown-item">Supprimer</a>
                </div>
            </div>
        </td>
        <td v-else-if="!this.isViewer" class="text-end">
            <ButtonDisplay
            :type="'cancel'"
            @click="updatingData = false" />
            <ButtonDisplay
            :type="'save'"
            @click="this.save(); updatingData = false" />
        </td>
    </tr>
</template>

<script>
import ButtonDisplay from '@/components/display/ButtonDisplay.vue'
import CorridoringDisplay from '@/components/display/CorridoringDisplay.vue'
import UserHelper from '@/helpers/user.helper.js'


export default {
    props: ['corridoring'],
    components: {
        ButtonDisplay,
        CorridoringDisplay
    },
    data() {
        return {
            updatingData: false,
            newName: null,
        };
    },
    computed: {
        isViewer() {
            return UserHelper.isViewer(this.$store.state.auth.user);
        },
    },
    mounted() {
        this.newName = this.corridoring.name;
    },
    methods: {
        save() {
            this.$emit("save", this.corridoring.id, this.newName);
        },
        delete() {
            this.$emit("delete", this.corridoring.id);
        },
    }
}
</script>